import React, { Component } from "react";
import "./style.css";
import { RightChevron } from "../../../../lib/icons";
import { TopLevelNavItem } from "../../../../components/topLevelNav/components/topLevelNavItem";
// import history from "lib/history";
// import onClickOutside from "react-onclickoutside";
import withOutsideClick from "../../../../hocs/withOutsideClick";
import { cloneDeep } from "lodash";
import {
  AppChartAnalytics,
  AppChartUser,
  AppChartBar,
  AppChartLine,
  AppChartLineDown,
  AppPie,
  FolderIcon,
  InputSourceIcon,
  ReportSvg,
  FolderMgmtIcon,
  ManageUsersIcon,
  EnvelopeIcon,
  CloseReportIcon,
  InsightsDiscoveryIcon,
} from "../../../../lib/icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { isRouteMatch, collectOpenNodeKeys, isNodeOpen, isNodeOpenInStack } from "../../../../lib/reportingNavigation";

class TopLevelParentNavItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDropDown: false,
      hovering: false,
    };
    this.renderDropDown = this.renderDropDown.bind(this);
    this.wrapperRef = React.createRef();
    // this.setWrapperRef = this.setWrapperRef.bind(this);
    // this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount() {
    window.addEventListener("blur", this.checkForIframeClick, false);
  }

  componentWillUnmount() {
    window.removeEventListener("blur", this.checkForIframeClick, false);
  }

  checkForIframeClick = (event) => {
    if (document.activeElement.tagName === "IFRAME") {
      this.setState({
        openDropDown: false,
      });
    }
  };

  handleClickOutside() {
    this.setState({ openDropDown: false });
  }

  handleInputChange(event, item) {
    this.props.filterTab(this.tabSearch.value, this.props.tab, this.props.selectedTab);
  }
  clickHandler(clicked, index, type) {
    const tempClicked = cloneDeep(clicked);
    // Always use this tab's own index (this.props.index) — not selectedTab[0] —
    // so that clicking a report in a non-active workspace's dropdown correctly
    // identifies that workspace as the target.
    const ownTabIdx = this.props.index;
    this.setState({ openDropDown: false });
    if (index.length === 2) {
      // index[0] is already the tab index (parentIndex == this.props.index),
      // index[1] is the folder/child index — pass through unchanged.
      this.props.clickHandler(clicked, index, type);
    } else {
      if (index.length === 4 || index.length === 3) {
        this.props.clickHandler(clicked, index, type);
      } else {
        const activeCount = this.props.tabs[ownTabIdx]?.activeChildren?.length || 0;
        tempClicked.index = [ownTabIdx, activeCount];
        this.props.clickHandler(tempClicked, [ownTabIdx, index], type);
      }
    }
  }
  renderChildren() {
    const { tab } = this.props;
    const routeSelection = this.props.routeSelection || {};
    const openKeys = collectOpenNodeKeys(tab.activeChildren);
    const wsId = tab.workspaceId || tab._id;
    const wsStack = (this.props.breadcrumbStacks || {})[wsId] || [];

    // folderPlaceHolder is a marker Report doc (name: "folderPlaceHolder") that
    // createFolder writes purely to anchor an empty PBI folder's path — it isn't a
    // real report and must never render as a nav-dropdown entry. Several call sites
    // build tab.children/activeWS.reports/activeWS.items from a workspace's raw,
    // unfiltered .reports array (e.g. reportIconListFolders.js, reportIconList/index.js,
    // topLevelNav/index.js), so filtering it out once here — the single place that
    // actually renders this list — covers all of them instead of requiring every
    // producer to remember to filter it themselves.
    const isNotFolderPlaceHolder = (node) => node?.name !== "folderPlaceHolder";

    if (tab.children !== undefined) {
      const children = tab.children.filter(isNotFolderPlaceHolder);
      return (
        <div className="parent-top-level-nav-item">
          {children.map((child, index) => {
            const pIndex = this.props.index;
            const selected = isRouteMatch(child, routeSelection);
            const isOpen = isNodeOpen(child, openKeys) || isNodeOpenInStack(child, wsStack);

            return (
              <TopLevelNavItem
                id={child.id}
                rptId={child.rptId}
                reportTestId={child._id || child.id}
                path={child.path}
                node={child}
                tab={tab}
                text={child.name}
                key={index}
                index={index}
                parentIndex={pIndex}
                type={child.type}
                fileType={child.fileType}
                selected={selected}
                isOpen={isOpen}
                openKeys={openKeys}
                wsStack={wsStack}
                selectedTab={this.props.selectedTab}
                clickHandler={this.clickHandler}
                removeHandler={this.props.removeHandler}
                routeSelection={routeSelection}
              />
            );
          })}
        </div>
      );
    } else {
      if (this.props.activeWS === undefined) {
        return <div />;
      }
      if (this.props.activeWS.reports === undefined) {
        if (this.props.activeWS.items.length > 0) {
          const items = this.props.activeWS.items.filter(isNotFolderPlaceHolder);
          return (
            <div
              className="parent-top-level-nav-item"
              style={{
                display: "flex",
                flexDirection: "column",
                overflowY: "scroll",
                height: "100%",
              }}>
              {items.map((child, index) => {
                const selected = isRouteMatch(child, routeSelection);
                const isOpen = isNodeOpen(child, openKeys) || isNodeOpenInStack(child, wsStack);

                return (
                  <TopLevelNavItem
                    id={child.id}
                    rptId={child.rptId}
                    reportTestId={child._id || child.id}
                    path={child.path}
                    node={child}
                    tab={tab}
                    text={child.name}
                    key={index}
                    index={index}
                    parentIndex={this.props.index}
                    type={child.type}
                    fileType={child.fileType}
                    selectedTab={this.props.selectedTab}
                    selected={selected}
                    isOpen={isOpen}
                    openKeys={openKeys}
                    wsStack={wsStack}
                    clickHandler={this.clickHandler}
                    removeHandler={this.props.removeHandler}
                    routeSelection={routeSelection}
                  />
                );
              })}
            </div>
          );
        }
      } else if (this.props.activeWS.reports && this.props.activeWS.reports.length > 0) {
        //do something special for tableau
        const reports = this.props.activeWS.reports.filter(isNotFolderPlaceHolder);
        return (
          <div
            className="parent-top-level-nav-item"
            style={{
              display: "flex",
              flexDirection: "column",
              overflowY: "scroll",
              height: "100%",
            }}>
            {reports.map((child, index) => {
              const selected = isRouteMatch(child, routeSelection);
              const isOpen = isNodeOpen(child, openKeys) || isNodeOpenInStack(child, wsStack);

              return (
                <TopLevelNavItem
                  id={child.id}
                  rptId={child.rptId}
                  reportTestId={child._id || child.id}
                  path={child.path}
                  node={child}
                  tab={tab}
                  text={child.name}
                  key={index}
                  index={index}
                  parentIndex={this.props.index}
                  type={child.type}
                  fileType={child.fileType}
                  selectedTab={this.props.selectedTab}
                  selected={selected}
                  isOpen={isOpen}
                  openKeys={openKeys}
                  wsStack={wsStack}
                  clickHandler={this.clickHandler}
                  removeHandler={this.props.removeHandler}
                  routeSelection={routeSelection}
                />
              );
            })}
          </div>
        );
      } else {
        return <div></div>;
      }
    }
  }
  renderDropDown() {
    const { tab, activeWS, workspaces } = this.props;

    let size;

    if (tab.children === undefined) {
      let group = {};
      if (tab.workspaceId === activeWS.workspaceId) {
        group = activeWS;
      } else {
        group = workspaces.filter((item) => {
          return item.workspaceId === tab.workspaceId;
        });
        group = group[0];
      }

      size = group.children.length;
      //tab.children = group.children;
    } else {
      size = tab.children.length;
    }
    size = 30 * size;
    if (size > 350) {
      size = 350;
    }
    return (
      // <div className="nav-dropdown" style={{ height: size + "px" }}>
      <div className="nav-dropdown">
        <div className="nav-dropdown-header"></div>
        <div style={{ paddingRight: "8px", paddingLeft: "8px" }}>
          <input
            className="input-box"
            placeholder="search"
            ref={(input) => (this.tabSearch = input)}
            onClick={(evt) => {
              evt.stopPropagation();
              evt.preventDefault();
            }}
            onChange={(event) => {
              this.handleInputChange(event, "search");
            }}
            style={{
              position: "relative",
              width: "100%",
            }}
          />
        </div>
        {this.renderChildren()}
      </div>
    );
  }
  render() {
    let icon = null;
    let selected = false;
    if (this.props.tab.icon !== undefined) {
      switch (this.props.tab.icon) {
        case 1:
          icon = (
            <div className="top-level-icon">
              <AppChartAnalytics
                height={"18px"}
                // width={"24px"}
                color={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case 2:
          icon = (
            <div className="top-level-icon">
              <AppChartUser
                height={"18px"}
                // width={"24px"}
                color={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case 3:
          icon = (
            <div className="top-level-icon">
              <AppChartBar
                height={"18px"}
                // width={"24px"}
                color={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case 4:
          icon = (
            <div className="top-level-icon">
              <AppChartLine
                height={"18px"}
                // width={"24px"}
                color={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case 5:
          icon = (
            <div className="top-level-icon">
              <AppChartLineDown
                height={"18px"}
                // width={"24px"}
                color={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case 6:
          icon = (
            <div className="top-level-icon">
              <AppPie
                height={"18px"}
                // width={"24px"}
                color={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case 7:
        case "files":
          icon = (
            <div className="top-level-icon">
              <FolderIcon
                height={"18px"}
                // width={"24px"}
                color={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case 11:
        case "mdm":
        case "mdh":
          icon = (
            <div className="top-level-icon">
              <InputSourceIcon
                height={"18px"}
                // width={"24px"}
                color={"white"}
                fill={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case 12:
        case "powerBI":
          icon = (
            <div className="top-level-icon" style={{ marginTop: "-3px" }}>
              <ReportSvg
                height={"16px"}
                // width={"24px"}
                color={"white"}
                fill={"white"}
                // viewBox={"0 -1 24 24"}
              />
            </div>
          );
          break;
        case "powerBIMgmt":
          icon = (
            <div className="top-level-icon" style={{ marginTop: "1px" }}>
              <FolderMgmtIcon
                height={"18px"}
                // width={"24px"}
                color={"white"}
                fill={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case "userManagement":
          icon = (
            <div className="top-level-icon" style={{ marginTop: "1px" }}>
              <ManageUsersIcon
                height={"18px"}
                // width={"24px"}
                color={"white"}
                fill={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case "reportSubscriptions":
          //TODO change to proper icon
          icon = (
            <div className="top-level-icon" style={{ marginTop: "1px" }}>
              <EnvelopeIcon
                height={"18px"}
                // width={"24px"}
                color={"white"}
                fill={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        case "insightsDiscovery":
          icon = (
            <div className="top-level-icon" style={{ marginTop: "1px" }}>
              <InsightsDiscoveryIcon
                height={"18px"}
                // width={"24px"}
                color={"white"}
                fill={"white"}
                viewBox={"-1 2 24 24"}
              />
            </div>
          );
          break;
        default:
          break;
      }
    }

    if (this.props.tab.activeChildren === null || this.props.tab.children === undefined) {
      if (this.props.selectedTab[0] !== -1) {
        if (this.props.tabs[this.props.selectedTab[0]].id === this.props.tab.id) {
          selected = true;
        }
      }
      return (
        <div
          className={"tab tab-parent " + (selected ? " tab-parent-selected" : "")}
          data-testid={`top-nav-tab-${this.props.tab.workspaceId || this.props.tab.type || this.props.index}`}
          ref={this.wrapperRef}
          // className={
          //   this.props.selected ? "tab tab-selected" : "tab tab-unselected"
          // }
          onMouseEnter={() => this.setState({ hovering: true })}
          onMouseLeave={() => this.setState({ hovering: false })}
          onClick={() => {
            this.props.clickHandler(this.props.tab, [this.props.index, -1], this.props.tab.type);
          }}
          key={this.props.index}
          // onClick={() => {
          //   this.setState({ openDropDown: !this.state.openDropDown });
          // }}
        >
          <div className="parent-nav-item">
            {(icon !== null || this.props.onClose) && (
              <div className="tab-icon-slot">
                {this.state.hovering && this.props.onClose ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tab-close-tip-${this.props.tab.workspaceId || this.props.tab.type || this.props.index}`}>
                        Close {this.props.tab.title}
                      </Tooltip>
                    }>
                    <div
                      className="top-level-close-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.props.onClose(this.props.tab);
                      }}
                      data-testid="tab-close-btn">
                      <CloseReportIcon height={"18px"} viewBox={"0 0 20 20"} color={selected ? "#fff" : "#58595B"} />
                    </div>
                  </OverlayTrigger>
                ) : (
                  icon
                )}
              </div>
            )}
            {this.props.tab.title}
          </div>
        </div>
      );
    } else {
      let title = this.props.tab.workspaceName;
      if (title === undefined || title === "") {
        title = this.props.tab.title;
      }
      if (this.props.tab.alias !== undefined && this.props.tab.alias !== "") {
        title = this.props.tab.alias;
      }

      selected = false;

      if (this.props.tabs[this.props.selectedTab[0]] !== undefined) {
        if (this.props.tabs[this.props.selectedTab[0]].workspaceId === this.props.tab.workspaceId) {
          selected = true;
        }
      }

      return (
        <div
          className={
            (this.state.openDropDown ? "tab tab-parent tab-parent-open" : "tab tab-parent") +
            (selected ? " tab-parent-selected" : "")
          }
          data-testid={`top-nav-tab-${this.props.tab.workspaceId || this.props.tab.type || this.props.index}`}
          ref={this.wrapperRef}
          // className={
          //   this.props.selected ? "tab tab-selected" : "tab tab-unselected"
          // }
          // onClick={() =>
          //   this.props.clickHandler(
          //     this.props.tab,
          //     this.props.index,
          //     this.props.tab.type
          //   )
          // }
          key={this.props.index}
          onMouseEnter={() => this.setState({ hovering: true })}
          onMouseLeave={() => this.setState({ hovering: false })}
          onClick={() => {
            // history.push("/reports/landing/" + this.props.tab.workspaceId);

            this.props.clickHandler(this.props.tab, [this.props.index, -1], "tab");
            //this.setState({ openDropDown: !this.state.openDropDown });
          }}>
          <div className="parent-nav-item">
            {(icon !== null || this.props.onClose) && (
              <div className="tab-icon-slot">
                {this.state.hovering && this.props.onClose ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tab-close-tip-${this.props.tab.workspaceId || this.props.tab.type || this.props.index}`}>
                        Close {title}
                      </Tooltip>
                    }>
                    <div
                      className="top-level-close-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.props.onClose(this.props.tab);
                      }}
                      data-testid="tab-close-btn">
                      <CloseReportIcon height={"18px"} viewBox={"0 0 20 20"} color={selected ? "#fff" : "#58595B"} />
                    </div>
                  </OverlayTrigger>
                ) : (
                  icon
                )}
              </div>
            )}
            {title}
            {this.state.openDropDown ? this.renderDropDown() : null}
          </div>
          {this.props.tab.children !== null && this.props.tab.children !== undefined && this.props.tab.children.length > 0 && (
            <div
              className="dd-chevron"
              style={{ position: "relative", top: "4px", paddingLeft: "2px" }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.setState({ openDropDown: !this.state.openDropDown });
              }}>
              <RightChevron
                transform={"rotate(90,12,12)"}
                height={"24px"}
                width={"24px"}
                color={"white"}
                viewBox={"0 -2 24 24"}
              />
            </div>
          )}
        </div>
      );
    }
  }
}

TopLevelParentNavItem = withOutsideClick(TopLevelParentNavItem);
export default TopLevelParentNavItem;
